/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type settingsDepartments_department$ref: FragmentReference;
declare export opaque type settingsDepartments_department$fragmentType: settingsDepartments_department$ref;
export type settingsDepartments_department = {|
  +id: string,
  +name: ?string,
  +sageIntacctId: ?string,
  +$refType: settingsDepartments_department$ref,
|};
export type settingsDepartments_department$data = settingsDepartments_department;
export type settingsDepartments_department$key = {
  +$data?: settingsDepartments_department$data,
  +$fragmentRefs: settingsDepartments_department$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "settingsDepartments_department",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sageIntacctId",
      "storageKey": null
    }
  ],
  "type": "DepartmentType"
};
// prettier-ignore
(node/*: any*/).hash = 'be83e662fd1cf7ee403c326f55b2425e';

module.exports = node;
